import { conformToMask } from 'vue-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default {
  name: 'MeasureMask',

  data() {
    return {
      numberMask: createNumberMask({
        prefix: '',
        suffix: '',
        allowDecimal: true,
        includeThousandsSeparator: false,
        decimalSymbol: ',',
      }),
    };
  },
  methods: {
    addDecimalMask(value) {
      if (value === null || value === undefined || value === '') return '';
      const val = Number(value).toFixed(2).replace('.', ',');
      const conformed = conformToMask(val, this.numberMask, { guide: false });
      return conformed.conformedValue;
    },
    removeDecimalMask(value) {
      if (!value) return null;
      return parseFloat(value.replace(',', '.'));
    },
  },
};
